import React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core';

const styles = {
  cardLink: {
    color: '#fff',
    padding: 0,
    marginTop: 16,
  },
  card: {
    fontSize: 14,
    color: '#fff',
  },
  cardHeader: {
    fontWeight: 400,
    padding: 0,
    color: '#fff',
  },
  cardBody: {
    margin: 0,
    padding: 0,
    paddingTop: 6,
  },
  cardContent: {
    padding: 6,
    // override CardContent default
    '&:last-child': {
      paddingBottom: 6,
    },
  },
};

const useStyles = makeStyles(styles);

export default function CardMoreInfoPrices() {
  const classes = useStyles();

  return (
    <a
      className={classes.cardLink}
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.vlaanderen.be/een-energiecontract-aangaan/soorten-energiecontracten"
    >
      <Card className={`${classes.card} bgdarkbluegreen`} elevation={0}>
        <CardContent className={classes.cardContent}>
          <CardHeader
            className={classes.cardHeader}
            disableTypography
            title="Meer informatie over dynamische elektriciteitscontracten"
          />
          <p className={classes.cardBody}>
            (met voordelige uurtarieven bij hoge groenestroomproductie)
          </p>
        </CardContent>
      </Card>
    </a>
  );
}
